import { z, ZodIssueCode, type ZodErrorMap } from 'zod'

/**
 * Mensajes de validación de Zod en español para los casos que los esquemas
 * del dominio no personalizan (mínimos, máximos, tipos). Los mensajes
 * explícitos de los esquemas siempre tienen prioridad.
 */
export const spanishErrorMap: ZodErrorMap = (issue, ctx) => {
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === 'undefined' || issue.received === 'null' || issue.received === 'nan') {
        return { message: 'Este campo es obligatorio' }
      }
      return { message: issue.expected === 'number' ? 'Ingrese un número válido' : 'Valor inválido' }
    case ZodIssueCode.too_small:
      if (issue.type === 'string') {
        return { message: issue.minimum === 1 ? 'Este campo es obligatorio' : `Mínimo ${String(issue.minimum)} caracteres` }
      }
      if (issue.type === 'array') return { message: `Seleccione al menos ${String(issue.minimum)}` }
      return { message: `Debe ser ${issue.inclusive ? 'mayor o igual a' : 'mayor que'} ${String(issue.minimum)}` }
    case ZodIssueCode.too_big:
      if (issue.type === 'string') return { message: `Máximo ${String(issue.maximum)} caracteres` }
      if (issue.type === 'array') return { message: `Máximo ${String(issue.maximum)} elementos` }
      return { message: `Debe ser ${issue.inclusive ? 'menor o igual a' : 'menor que'} ${String(issue.maximum)}` }
    case ZodIssueCode.invalid_string:
      if (issue.validation === 'email') return { message: 'Correo electrónico inválido' }
      if (issue.validation === 'url') return { message: 'Dirección web inválida (debe iniciar con https://)' }
      if (issue.validation === 'uuid') return { message: 'Identificador inválido' }
      return { message: 'Formato inválido' }
    case ZodIssueCode.invalid_enum_value:
      return { message: 'Seleccione una opción válida' }
    case ZodIssueCode.not_multiple_of:
      return { message: 'Debe ser un número entero' }
    default:
      return { message: ctx.defaultError }
  }
}

/** Instala los mensajes en español (una vez, al iniciar la app y en las pruebas). */
export function installSpanishErrorMap(): void {
  z.setErrorMap(spanishErrorMap)
}
